import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoMdFootball } from "react-icons/io";
import axios from "axios";
import { useContext } from "react";
import { PitchContext } from "../context/PitchContex";

function RenewPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const {
    navigate,
    backendURL,
    setAlertMessage,
    setIsErr,
    setShowAlert,
    setPending,
  } = useContext(PitchContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setIsErr(true);
      setAlertMessage("Şifreler eşleşmiyor.");
      setShowAlert(true);
      return;
    }

    setPending(true);

    axios
      .post(backendURL + "user/update-password", {
        token,
        newPassword: password,
      })
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          navigate("/giris-yap");
          setIsErr(false);
          setAlertMessage(response.data.message);
          setShowAlert(true);
        } else {
          setIsErr(true);
          setAlertMessage(response.data.message);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setPending(false);
        setIsErr(true);
        setAlertMessage(err.response.data.message);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="my-10 sm:my-0 sm:min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
        <div className="flex items-center justify-center gap-2 mb-6">
          <h1 className="text-3xl font-bold tracking-tight">
            H<span className="text-[#6ca87e]">A</span>LIS
            <span className="text-[#6ca87e]">A</span>H
            <span className="text-[#6ca87e]">A</span>M
          </h1>
          <IoMdFootball className="text-3xl text-[#6ca87e]" />
        </div>

        <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
          Yeni Şifre Oluştur
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Yeni Şifre
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
              placeholder="Yeni şifrenizi girin"
            />
          </div>

          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-gray-700"
            >
              Şifreyi Onayla
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-colors"
              placeholder="Şifrenizi tekrar girin"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[#6ca87e] text-white py-2 rounded-md hover:bg-[#5a906a] transition-colors duration-300 font-medium cursor-pointer"
          >
            Şifreyi Güncelle
          </button>
        </form>
      </div>
    </div>
  );
}

export default RenewPassword;
